<ng-container *ngIf="initialized">

    <!--    <p-messages [(value)]="validationMessages" [enableService]="false" [closable]="false"></p-messages>-->
    @if (validationMessages?.length) {
        <p-messages [value]="validationMessages"></p-messages>
    }

    <ng-container *ngFor="let widgetForm of widgetConfigForms.forms">
        <div class="text-lg font-medium text-color-secondary my-3 col-12 py-0">{{ widgetForm.label }}</div>
        <ng-template mvs-widget-config-component-directive></ng-template>
    </ng-container>

</ng-container>



